export const APPLICANT_VISIBLE_APPLICATION_STATUSES = Object.freeze([
	'invitation',
	'pending',
	'interview',
	'hired',
	'denied'
])

export const APPLICANT_WITHDRAWABLE_APPLICATION_STATUSES = Object.freeze([
	'pending',
	'requested',
	'accepted',
	'invitation',
	'interview'
])

export function canApplicantWithdrawApplication(
	application,
	jobOffer = application?.job_offer
) {
	return Boolean(
		jobOffer &&
			APPLICANT_WITHDRAWABLE_APPLICATION_STATUSES.includes(
				application?.status
			)
	)
}

export function getApplicationPrimaryColumnLabelKey(isOrg = false) {
	return isOrg ? 'general.applicant' : 'general.job'
}

const APPLICATION_STAGE_LABEL_KEYS = Object.freeze({
	pending: 'general.requested',
	requested: 'general.requested',
	invitation: 'general.invited',
	accepted: 'general.accepted',
	interview: 'general.interview',
	hired: 'general.hired',
	denied: 'general.denied'
})

export function getVisibleApplicationStatus(status, isOrg = false) {
	if (!isOrg && ['pending', 'requested', 'accepted'].includes(status)) {
		return 'pending'
	}

	return status
}

export function getApplicationStageLabelKey(
	status,
	isOrg = false,
	declineSource = null
) {
	if (!isOrg && status === 'denied' && declineSource === 'withdrawn') {
		return 'application.withdrawn'
	}

	const visibleStatus = getVisibleApplicationStatus(status, isOrg)

	return APPLICATION_STAGE_LABEL_KEYS[visibleStatus] || 'general.unknown'
}

export function applicationsForVisibleStage(
	applications,
	visibleStatus,
	isOrg = false
) {
	return (applications || []).filter(
		application =>
			getVisibleApplicationStatus(application.status, isOrg) ===
			visibleStatus
	)
}
